var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { useHotkeys as useHotkeysHook } from 'react-hotkeys-hook';
var defaultOptions = {
    enableOnContentEditable: false,
    filterPreventDefault: false
};
export var useHotkeysKey = function (key, callback, options) {
    useHotkeysHook(key, callback, __assign(__assign({}, defaultOptions), options), [callback]);
};
/**
 * @param code with azerty a=KeyQ, escape=Escape, space=Space
 */
export var useHotkeysCode = function (code, callback, options) {
    useHotkeysHook('*', callback, __assign(__assign({ filter: React.useCallback(function (e) { return e.code === code; }, [code]) }, defaultOptions), options), [callback]);
};
